export default __webpack_public_path__ + "static/media/landingbg.c8ad5dd4.png";